import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
const BEFORE = ['Dudas constantes', 'Práctica inestable', 'Información confusa', 'Dependencia externa'];
const AFTER = ['Claridad y confianza', 'Práctica diaria simple', 'Conexión real', 'Autonomía espiritual'];
export function BeforeAfterSection() {
  return <section className="bg-gray-50 py-20 md:py-28 px-4" data-id="element-17">
      <div className="container mx-auto max-w-3xl" data-id="element-18">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-5xl font-serif font-bold text-gray-900 text-center mb-14 leading-tight" data-id="element-19">
          🔄 Antes vs Después
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-20">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-2xl p-8 border-2 border-red-100 shadow-sm" data-id="element-21">
            <h3 className="text-xl font-bold text-red-500 mb-6 flex items-center gap-2" data-id="element-22">
              <X className="w-6 h-6" strokeWidth={3} data-id="element-23" /> Antes
            </h3>
            <ul className="space-y-4" data-id="element-24">
              {BEFORE.map((item, idx) => <li key={idx} className="flex items-center gap-3 text-gray-600 text-lg" data-id="element-25">
                  <span className="w-2 h-2 bg-red-300 rounded-full flex-shrink-0" data-id="element-26"></span>
                  {item}
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-2xl p-8 border-2 border-green-200 shadow-md ring-1 ring-green-100" data-id="element-27">
            <h3 className="text-xl font-bold text-green-600 mb-6 flex items-center gap-2" data-id="element-28">
              <Check className="w-6 h-6" strokeWidth={3} data-id="element-29" /> Después
            </h3>
            <ul className="space-y-4" data-id="element-30">
              {AFTER.map((item, idx) => <li key={idx} className="flex items-center gap-3 text-gray-800 font-medium text-lg" data-id="element-31">
                  <div className="bg-green-100 p-0.5 rounded-full flex-shrink-0" data-id="element-32">
                    <Check className="w-4 h-4 text-green-600" strokeWidth={3} data-id="element-33" />
                  </div>
                  {item}
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}